import { ReactNode } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  getRouteCreateProject,
  getRouteNewVersion,
  getRouteProjectDetails,
  getRouteProjects,
  getRouteReviewRelaunch,
  getRouteSettings
} from "@/zapi-frontend/shared/const/router";
import { AppHeader as DsAppHeader, AppHeaderContent } from "@/zapi-frontend/widgets/Header/ui/blocks/AppHeader";
import { AccountBar } from "./_AccountBar";
import { AppHeader } from "./_AppHeader";
import { ProjectDetailsHeader } from "./_ProjectDetailsHeader";
import { NewProjectHeader } from "./_NewProjectHeader";
import { PortfolioHeader } from "./_PortfolioHeader";

type THeaderProps = { slot?: ReactNode };

export function Header({ slot }: THeaderProps) {
  const { pathname } = useLocation();
  const { id, projectId } = useParams();
  const isProjectPage = !!id && pathname === getRouteProjectDetails(id);
  const isCreatePage = pathname === getRouteCreateProject();
  const isVersionSetup =
    !!projectId && (pathname === getRouteNewVersion(projectId) || pathname === getRouteReviewRelaunch(projectId));
  const isPortfolioHome = pathname === getRouteProjects();
  const isSettingsPage = pathname === getRouteSettings();

  if (isPortfolioHome)
    return (
      <DsAppHeader surfaceOnScroll data-testid="header-container">
        <AppHeaderContent layout="centered">
          <PortfolioHeader />
        </AppHeaderContent>
      </DsAppHeader>
    );

  if (isSettingsPage)
    return (
      <DsAppHeader surfaceOnScroll data-testid="header-container">
        <AppHeaderContent layout="split" className="max-w-none">
          <PortfolioHeader withCenterSlot={false} />
        </AppHeaderContent>
      </DsAppHeader>
    );

  if (isProjectPage || isCreatePage || isVersionSetup)
    return (
      <DsAppHeader surfaceOnScroll data-testid="header-container">
        <AppHeaderContent layout="split" className="max-w-none">
          {isCreatePage ? <NewProjectHeader /> : <ProjectDetailsHeader end={<AccountBar />} />}
        </AppHeaderContent>
      </DsAppHeader>
    );

  return (
    <div
      data-testid="header-container"
      className="bg-white h-14 shrink-0 relative flex justify-between items-center gap-4 pl-[16px] pr-3"
    >
      <AppHeader />
      <div className="flex items-center gap-2 w-fit">{slot}</div>
    </div>
  );
}
